<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout justify-space-between row wrap>
        <v-flex v-for="(item, i) in informations" :key="i" :class="item.class">
          <v-list three-line light class="py-0 elevation-2">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="font-weight-bold">{{item.title}}</v-list-tile-title>
                <v-list-tile-sub-title class="text--primary">{{item.subtitle}}</v-list-tile-sub-title>
                <v-list-tile-sub-title>{{item.value | currency}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-flex>
      </v-layout>
      <v-layout justify-start row wrap>
        <v-flex xs12>
          <v-divider light></v-divider>
        </v-flex>
        <v-flex xs12 sm6>
          <h3>Outros Valores</h3>
        </v-flex>
        <v-flex xs12 sm6 >
          <v-btn v-if="!budgetFinalized" block color="primary" title="Adicionar Outro Valor" @click.native.stop.prevent="addBenefit();">
            Adicionar
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-layout v-show="moduleFive.others.length > 0" v-for="(item, i) in moduleFive.others" :key="i">
            <v-flex :class="budgetFinalized ? 'xs12' : 'xs11'">
              <v-layout justify-start row wrap>
                <v-flex xs12 sm6>
                  <v-text-field label="Descrição" v-model="item.description" box :readonly="budgetFinalized"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-currency-field 
                    box :readonly="budgetFinalized"
                    label="Valor" 
                    v-bind="currency_config"
                    v-model="item.value"
                  >
                  </v-currency-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs1 v-if="!budgetFinalized">
              <v-layout align-center justify-center row fill-height>
                <v-icon class="red--text font-weight-black" title="Remover benefício" @click.stop.prevent="removeBenefit(item);">delete_forever</v-icon>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12>
          <v-divider light></v-divider>
        </v-flex>
        <v-flex xs12 class="pt-0">
          <v-textarea v-model="moduleFive.notes" label="Notas" rows="5" box :readonly="budgetFinalized"></v-textarea>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import ModuleFiveService from '../../service/ModuleFiveService';
  import SheetDefaultData from '../../data/sheet/SheetDefaultData'
  import {mapState} from "vuex";
import Currency from '../../utils/Currency';
  export default {

    name: "TabSummaryTable",
    data(){
      return{
        currency_config: Currency.real
      }
    },
    methods: {
      addBenefit() {
        if(!this.moduleFive.others)
          this.moduleFive.others = new Array()

        this.moduleFive.others.push({
          description: "",
          value: 0,
        });
      },
      removeBenefit(item) {
        this.moduleFive.others.splice(this.moduleFive.others.indexOf(item), 1);
      },
      async setSheetModuleFive() {
        let sheet = this.$store.getters.getAnalyticalWorksheet
          if(sheet.moduleFive != this.moduleFive){
            sheet.moduleFive = Object.assign({}, this.moduleFive)
            await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);
          }
      }, // setSheetModuleFive()
    },
    computed: {
      othersValue(){
        return ModuleFiveService.getOthers(this.moduleFive.others)
      },
      informations(){
        
        return [
          {
            class: "xs12 sm6 md3",
            title: "Uniformes e EPI's (Mês)",
            subtitle: "",
            value: this.amountOfUniformsByMonth.value
          },
          {
            class: "xs12 sm6 md3",
            title: "Materiais de Consumo (Mês)",
            subtitle: `Total de Empregados: ${this.amountOfConsumablesByMonth.employees}`,
            value: this.amountOfConsumablesByMonth.value
          },
          {
            class: "xs12 sm6 md3",
            title: "Equipamentos (Mês)",
            subtitle: `Total de Empregados: ${this.amountOfEquipmentsByMonth.employees}`,
            value: this.amountOfEquipmentsByMonth.value
          },
          {
            class: "xs12 sm6 md3",
            title: "Utensílios (Mês)",
            subtitle: `Total de Empregados: ${this.amountOfUtensilsByMonth.employees}`,
            value: this.amountOfUtensilsByMonth.value
          },

          {
            class: "xs12",
            title: "TOTAL DO MÓDULO 5 (MÊS)",
            value: this.amountOfModuleFive
          },

          
        ]
      },
      amountOfModuleFive() {
        let amount = this.amountOfUniformsByMonth.value + 
                this.amountOfUtensilsByMonth.value + 
                this.amountOfEquipmentsByMonth.value + 
                this.amountOfConsumablesByMonth.value + 
                this.othersValue
        this.$store.commit("SET_AMOUNT_OF_MODULE_FIVE", amount);
        return amount
      },
      moduleFive(){
        if(this.analyticalWorksheet.moduleFive)
          return this.analyticalWorksheet.moduleFive
        
        return SheetDefaultData.getModuleFive()
      },
      ...mapState({amountOfUniformsByMonth    : state => state.budget.amountOfUniformsByMonth}),
      ...mapState({amountOfUtensilsByMonth    : state => state.budget.amountOfUtensilsByMonth}),
      ...mapState({amountOfConsumablesByMonth : state => state.budget.amountOfConsumablesByMonth}),
      ...mapState({amountOfEquipmentsByMonth  : state => state.budget.amountOfEquipmentsByMonth}),
      ...mapState({analyticalWorksheet        : state => state.budget.analyticalWorksheet}),      
      ...mapState({budgetFinalized: state => state.budget.budgetFinalized})
    },
    watch: {
      moduleFive: {
        handler: function(newValue, oldValue) {
          this.setSheetModuleFive()
        },
        deep: true
      }
    }
  }

</script>


// WEBPACK FOOTER //
// src/components/budget/TabModule5.vue